<section id="info">
    <div class="container-fluid">

        <div class="row">
            <div class="col-md-12">
                <h5>AVISO SOBRE EL USO DE COOKIES</h5>
                <p>
                    En Sorteo Anáhuac, valoramos tu privacidad. Utilizamos cookies. para mejorar tu experiencia de
                    navegación, personalizar contenido y analizar nuestro tráfico web. Aquí puedes encontrar más
                    información sobre las cookies que utilizamos y cómo gestionar tus preferencias Consulta nuestro
                    aviso de privacidad.
                </p>

                <div class="row">
                    <div class="col-md-6 text-md-right text-center mt-3 mb-3">
                        <a (click)="acceptInfo()" class="btn-stack">Aceptar</a>
                    </div>
                    <div class="col-md-6 text-md-left text-center mt-3 mb-3">
                        <a (click)="closeModal()" class="btn-stack">Rechazar</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>


<div class="btn-call">
    <a href="https://api.whatsapp.com/send?phone=+525531332409&text=hola!%20Sorteo" target="_blank">
        <div class="row">
            <div class="col-4 text-right p-0 my-auto">
                <img src="/assets/images/sorteo2023/btn-whats.png" class="img-fluid">
            </div>
            <div class="col-8 p-0 my-auto">
                <span>Contáctanos <br>por whatsapp</span>
            </div>
        </div>
    </a>
</div>
<!-- <div class="btn-call btn-go-buy">
    <a href="{{ urlMicrositioAniv }}/compra-en-linea-boletos-sorteo-anahuac{{utmUrl}}" target="_blank">
        <img src="/assets/images/sorteo2025/btn-buy-green.png"  >
    </a> 
</div>

<div class="btn-call btn-go-buy" style="top: 65%;">
    <a href="{{urlMicrositio}}/compra-en-linea-boletos-sorteo-anahuac{{utmUrl}}" target="_blank">
        <img src="/assets/images/sorteo2023/btn-buy-red.png"  >
    </a> 
</div> -->

<!-- <section class="campus">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h5 class="text-center">
                    nuestra comunidad
                </h5>
            </div>
            
            <div class="col-md-3 text-center my-auto">
                <img src="/assets/images/sorteo2023/redes.png" class="img-fluid" alt="Red de Universidades Anáhuac">
            </div>
           
            <div class="col-md-3 text-right my-auto">
               <img src="/assets/images/sorteo2023/red.png" class="img-fluid" alt="Red de Colegios Semper Altius">
            </div>

            <div class="col-md-3 text-center my-auto">
                <img src="/assets/images/sorteo2023/anahuac.png" class="img-fluid" alt="Prepa Anáhuac">
            </div>

            <div class="col-md-3 text-center my-auto">
                <img src="/assets/images/sorteo2023/ufv.png" class="img-fluid" alt="UFV">
            </div>
            <div class="col-md-3 text-center my-auto">
                <img src="/assets/images/sorteo2023/iada.png" class="img-fluid" alt="IADA">
            </div>

        </div>
    </div>
</section> -->

<section id="parthers">
    <div class="container-fluid">
        <div class="row">

            <div class="col-md-12 text-center">
                <div class="overlap-signature">
                    <h2 class="main-text">Nuestra</h2>
                    <span class="letter"><span class="signature-text">comunidad</span></span>
                </div>
            </div>

            <div class="col-md-12 text-center">

<!-- 
                <a href="https://www.ufv.es/" target="_blank">
                    <img src="/assets/images/sorteo2025/ufv.png" class="img-fluid img-same-dimensions" alt="UFV">
                </a>
 -->


                <a href=" https://www.prepaanahuac.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/anahuac.png" class="img-fluid img-same-dimensions"
                        alt="Prepa Anáhuac">
                </a>



                <a href="https://iada.anahuac.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/iada.png" class="img-fluid img-same-dimensions" alt="IADA">
                </a>




                <a href=" https://www.anahuac.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/redes.png" class="img-fluid img-same-dimensions"
                        alt="Red de Universidades Anáhuac">
                </a>


                <a href="https://www.semperaltius.edu.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/red.png" class="img-fluid img-same-dimensions"
                        alt="Red de Colegios Semper Altius">
                </a>

            </div>
        </div>
    </div>
</section>






<footer id="main-footer">
    <div class="container">
        <div class="row">


       
            <div class="col-lg-4 my-auto ">
                <ul>
                    <!-- <li>
                        <a class="d-block" [routerLink]="['/reglamento-becario']">
                            Reglamento del Sorteo Anáhuac para Becarios Colaboradores
                        </a>
                    </li> -->
                    <li>
                        <a class="d-block" [routerLink]="['/aviso-de-privacidad']">
                            Aviso de privacidad
                        </a>
                    </li>
                    <li>
                        <a class="d-block" [routerLink]="['/terminos-y-condiciones']">
                            Términos
                            y Condiciones
                        </a>
                    </li>
                    <li>
                        <a class="d-block" [routerLink]="['/carta-de-confidencialidad']">
                            Carta de Confidencialidad
                        </a>
                    </li>
                    <li>
                        <a class="d-block" href="http://www.juegosysorteos.gob.mx/es/Juegos_y_Sorteos/Atencion_al_Ludopata" target="_blank">
                           Juego Responsable
                        </a>
                    </li>
                     <li>
                        <a class="d-block" [routerLink]="['/bases-del-sorteo-magno']" target="_blank">
                          Bases del Sorteo Magno
                        </a>
                    </li>
                     <!-- <li>
                        <a class="d-block"  [routerLink]="['/bases-del-sorteo-aniversario']" target="_blank">
                          Bases del sorteo Aniversario
                        </a>
                    </li> -->
                </ul>

            </div>


            <div class="col-lg-4  my-md-auto mt-4 mb-4">
                <h5>
                    Contacto
                </h5>
                <h4>
                    ¿En qué te podemos ayudar hoy?
                </h4>
                <a href="/contacto" class=" d-block text-decoration-underline" target="_blank">
                    <span style="border-bottom: 2px solid #333;">Haz clic aquí para ponerte en contacto</span>
                </a>

                <!-- <a class=" d-block text-decoration-underline" target="_blank" >
                    <strong> <span >ATENCIÓN A GANADORES</span></strong>
                </a> -->
                <!-- <a href="https://api.whatsapp.com/send?phone=525540525533&text=Hola"  target="_blank" class="whats d-block" target="_blank">
                    <i class="fa fa-whatsapp" aria-hidden="true" style="color: #fc5705;font-size: 22px;margin-right: 5px;"></i> 55 4052 5533  
                </a> -->

                <a href="mailto:sorteoanahuac@anahuac.mx" class=" d-block" target="_blank">
                    <i class="fa fa-envelope" aria-hidden="true"
                        style="color: #fc5705;font-size: 20px;margin-right: 5px;"></i> sorteoanahuac@anahuac.mx
                </a>
                <!-- <a href="tel:5556270210" class=" d-block" target="_blank">
                    <i class="fa fa-phone" aria-hidden="true"
                        style="color: #fc5705;font-size: 20px;margin-right: 5px;"></i> 55 5627 0210 Ext. 7474
                </a> -->
                <!-- <a href="mailto:sorteoanahuac@anahuac.mx" class=" d-block" target="_blank">
                    <i class="fa fa-envelope" aria-hidden="true" style="color: #fc5705;font-size: 20px;margin-right: 5px;"></i> sorteo.ganadores@anahuac.mx
                </a> -->
                <p>
                    <strong>Recuerda</strong> que para participar en nuestros Sorteos debes ser mayor de 18 años.
                </p>
            </div>

            <div class="col-lg-4 my-auto redes text-lg-center">
                <h5>
                    síguenos
                </h5>
                <a href="https://www.facebook.com/share/1DeSSeqMuR/?mibextid=wwXIfr" target="_blank">
                    <img src="assets/images/sorteo2023/facebook.png" alt="Facebook" class="img-fluid">
                </a>

                <a href="https://www.instagram.com/sorteosanahuac?dlrf=MXM1cW4zbmJzaTlkMg%3D%3D&utm_source=qr" target="_blank">
                    <img src="assets/images/sorteo2023/instagram.png" alt="Instagram" class="img-fluid">
                </a>

                <a href="https://x.com/sorteoanahuac?s=21" target="_blank">
                    <img src="assets/images/sorteo2024/x.png" alt="twitter" class="img-fluid">
                </a>

                <a href="https://youtube.com/@sorteoanahuac_oficial?si=gh7BJN8sujBLDCAX" target="_blank">
                    <img src="assets/images/sorteo2023/youtube.png" alt="youtube" class="img-fluid">
                </a>

                <a href="https://www.linkedin.com/company/sorteoanahuac/" target="_blank">
                    <img src="assets/images/sorteo2023/linkedin.png" alt="linkedin" class="img-fluid">
                </a>

                <a href="https://www.tiktok.com/@sorteosanahuac?_r=1&_t=ZS-9AuJhcOEEQ1" target="_blank">
                    <img src="assets/images/sorteo2023/tiktok.png" alt="tiktok" class="img-fluid">
                </a>

            </div>

            <div class="col-md-12 text-md-center my-auto legals pt-4">
                <p>
                    Sorteo Anáhuac A.C. R.F.C.:SAN1501298V6. Av. Universidad Anáhuac #46 Col. Lomas Anáhuac,
                    Huixquilucan, Estado de México C.P.52786

                </p>
     
                <p>
                    <strong>Permiso SEGOB Sorteo Anáhuac Magno: 20260061PS09</strong>
                </p>
            </div>


        </div>
    </div>



</footer>

<section class="derechos">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <p class="m-0 p-0">
                    ©SorteoAnáhuac A.C. Algunos derechos reservados.
                </p>
            </div>
        </div>
    </div>
</section>